import { render } from "./v-radio.vue?vue&type=template&id=0c75cf6b"
import script from "./v-radio.vue?vue&type=script&lang=js"
export * from "./v-radio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__